<template>
    <v-app-bar
    clipped-left
    app
    color="white"
    dark
    height="79.75"
    elevation="1"
    class="main-header-vue"
    >

      <div class="pl-5">

        <div class="d-flex align-center">

          <v-img
          class="shrink mr-2"
          contain
          src="@/assets/Logo_rasmi_JMG.png"
          transition="scale-transition"
          width="40"
          />

          <v-img
          class="shrink ml-4"
          contain
          src="@/assets/Mygems_logo.png"
          transition="scale-transition"
          width="110"
          />

          <!-- <h2>MyGEMS</h2> -->

        </div>

        <v-spacer></v-spacer>

      </div>

    </v-app-bar>
</template>

<script>
// import axios from 'axios';

export default {

  data: () => ({
    
  }),

  mounted() {
    this.load()
  },

  methods: {
      
    load(){

      
    }

  },

};
</script>

<style lang="scss">
@import '@/assets/styles/main.css';

.main-header-vue{
  z-index: 50 !important;
}
</style>